export const step1 = {
  name: {
    value: '',
    isValid: false,
  },
  rut: {
    value: '',
    isValid: false,
  },
  documentNumber: {
    value: '',
    isValid: false,
  },
  quantityFinancialEntity:{
    value: '',
    isValid: false,
  },
  checkExecutive: {
    value: false,
    isValid: false,
  },
  executiveEmail: {
    value: '',
    isValid: false,
  },
  meansContact: {
    value: '',
    isValid: false,
  },
  check: {
    value: false,
    isValid: false,
  },
  checkEquifax: {
    value: false,
    isValid: false,
  },
  liquidIncome: {
    value: '',
    isValid: false,
  },
  lists: {
    value: null,
    isValid: false,
  },
  modal: {
    value: {
      isOpen: false,
      type: 'alert',
      headline: '',
      bodyMessage: '',
      primaryButtonLabel: '',
      primaryAction: null,
    },
  },
  modalWellcomeMessage: {
    value: true,
    isValid: true, 
  },
  stepsStepper: [
    'Datos personales',
    'Datos de contacto',
    'Entidad financiera',
  ],
};